import React from 'react';
import { Card, Col, Row } from 'reactstrap';

import styles from './Dashboard.module.scss';

import DashboardCard from './DashboardCard';
import PageLoader from '../../components/Common/loader/PageLoader';

import { DashboardCardData, isLoginUserAdmin } from '../../api-services/filters.api';
import Environment from '../../environment/Environment';
import HelpModal from '../../components/Common/Modals/HelpModal';


interface Props {
}

interface State {
  isLoading: boolean;
  dashboardList: {
    tab: string;
    cards: {
      title: string;
      time?: string;
      location?: string;
      productHierarchy?: string;
      totalSeasons?: any;
      activePreSeasons?: any;
      targetPreSeasons?: any;
      quarters?: string;
      path: string;
    }[];
  }[];
  selectedTab: string;
  isInfoModalOpen: boolean;
  helpHtml: string;
}

const userNames = [
  '8f604d2e-db8b-4307-8fd1-4c152e6c697e',
  'd2ffde86-51d1-4d1d-bf0e-d3cbc3143df8',
];

export default class Dashboard extends React.Component<Props, State> {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      dashboardList: [],
      selectedTab: '',
      isInfoModalOpen: false, // <-- Add this state
      helpHtml: '', // <-- Add this
    };
  }

  componentDidMount() {
    this.getDashboardCardData();
    this.isLoginUserCheck();
  }

  isLoginUserCheck(): void{
    const params = {
      userId: sessionStorage.getItem('userName'),
    };
    isLoginUserAdmin(params)
      .then((res) => {
        if(!!res){
            sessionStorage.setItem('isAdminUser', res.isAdminUser);     
        }else{
          sessionStorage.setItem('isAdminUser', 'false');
        }
    });
  }

  getDashboardCardData(): void {
    const params = {
      userId: sessionStorage.getItem('userName'),
    };

    DashboardCardData(params)
      .then((res) => {
        if (!!res) {
          this.setState({
            dashboardList: res.dashboardList
            /*.map((dashboard) => ({
              ...dashboard,
              cards: dashboard.cards.filter((card) => !['13', '14'].includes(card.planId))
            }))*/,
            selectedTab: res.selectedTab,
            isLoading: false,
          });
        }
      });
  }

  render(): React.ReactNode {
    if (this.state.isLoading) {
      return (
        <React.Fragment>
          <PageLoader
            status={this.state.isLoading}
          />
        </React.Fragment>
      );
    }

    return (
      <React.Fragment>
        <div className="page-content">
          <Row>
            <Col md={12}>
              <Card className={styles['card-body']} style={{ position: 'relative' }}>

                {/* Info icon in top-right */}
                <span
                  className={styles['info-icon']}
                  title="Help"
                  onClick={() => this.setState(() => this.setState({ isInfoModalOpen: true }))}
                  style={{ cursor: 'pointer' }}
                >
                  ℹ️
                </span>

                <Row className={styles['card-section']}>
                  
                  <Col md={12} className="p-0">
                    <div className="d-flex">
                      {
                        this.state.dashboardList
                        /*.filter((data) => userNames
                          .includes(sessionStorage.getItem('userName') || '')
                          ? true
                          : data.tab !== 'Configuration')*/
                          .map((data, tabIdx: number) => (
                            <div
                              key={tabIdx}
                              className={`tab ${data.tab === this.state.selectedTab ? 'active' : ''}`}
                              onClick={() => this.setState({ selectedTab: data.tab })}
                            >
                              <p className={`tab-text ${data.tab === this.state.selectedTab ? 'active' : ''}`}>
                                {data.tab}
                              </p>
                            </div>
                          ))
                      }
                    </div>
                  </Col>

                  <Col md={12} className='p-0'>
                    <Row>
                      {
                        this.state.dashboardList
                          .filter((list) => list.tab === this.state.selectedTab)[0].cards
                        /*.filter((card) => userNames
                          .includes(sessionStorage.getItem('userName') || '')
                          ? true : !['SKU Level Sales Plan', 'SKU Level Rolling Plan'].includes(card.title))*/
                          .map((card, cardIdx: number) => (
                            <Col md={4} key={cardIdx}>

                              <DashboardCard
                                dataSource={card}
                              />

                            </Col>
                          ))
                      }
                    </Row>
                  </Col>
                </Row>

              </Card>
            </Col>
          </Row>
        </div>
        {<HelpModal
          isOpen={this.state.isInfoModalOpen}
          toggle={() => this.setState({ isInfoModalOpen: !this.state.isInfoModalOpen })}
          docUrl={'api/help/docs'}
        />}

      </React.Fragment>
    );
  }
}


